import { PureComponent } from "react";
import ParagraphAndAssetColumnsComponent from "/components/core/paragraph-and-asset-columns/paragraph-and-asset-columns-component";

export default class TextAndAssetComponent extends PureComponent {
  constructor(props) {
    super(props);
  }

  render() {
    const { marginTop } = this.props;
    return (
      <div className="paragaph-and-asset-component" style={{ marginTop }}>
        <ParagraphAndAssetColumnsComponent {...this.props} />
      </div>
    );
  }
}

TextAndAssetComponent.defaultProps = {
  content: {
    topic: {
      text: "Simple and intuitive",
      color: "brand-blue"
    },
    title: "Easy onboarding, fast adoption",
    body: [
      "Getting your team onboard recuires sending an invatation, and that’s it! It’s so visual and easy to use your teammates will get hooked immediatly."
    ],
    bottomLink: {
      href: "/",
      text: "See all features"
    }
  },
  asset: {
    side: "right",
    shadow: false
  }
};
